<template>
  <v-container class="pt-1" fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex md12>
        <material-card color="#4cc7e8" title="Suppliers" offset="0">
          <v-text-field
            v-model="searchSuppliers"
            label="Search"
            single-line
            hide-details
            prepend-icon="mdi-magnify"
            clearable
          ></v-text-field>
          <div slot="header-actions">
            <v-btn
              v-if="formOpen && formData.id != 'S3vYx4RKfvQwvpUh72uv'"
              :loading="deleting"
              small
              raised
              color="error"
              class="mr-2"
              @click="deleteBusiness()"
              >Delete</v-btn
            >
            <v-btn small raised color="info" @click="toggleForm()">{{
              formOpen ? "Close" : "Add"
            }}</v-btn>
          </div>
          <v-sheet v-if="formOpen" class="mt-2">
            <v-tabs
              v-model="activeTab"
              color="grey lighten-1"
              dark
              slider-color="black"
            >
              <v-tab ripple>Details</v-tab>
              <v-tab ripple>Public Profile</v-tab>
              <v-tab ripple>Services</v-tab>
              <v-tab ripple>Our Work</v-tab>
              <v-tab ripple>Testimonials</v-tab>
              <v-tab v-if="userData.role.includes('Admin')" ripple
                >Product Details</v-tab
              >
              <v-tab v-if="userData.role.includes('Admin')" ripple
                >Promotions</v-tab
              >
              <v-tab v-if="userData.role.includes('Admin')" ripple
                >Learn More</v-tab
              >
              <v-tab v-if="userData.role.includes('Admin')" ripple
                >Locations</v-tab
              >
              <v-spacer />
              <v-btn :loading="saving" color="success" @click="save"
                >Save</v-btn
              >
              <v-tab-item>
                <v-card flat>
                  <v-card-text>
                    <v-form ref="businessForm">
                      <v-layout key="form" wrap justify-center>
                        <v-flex xs12>
                          <strong>ID: {{ formData.id }}</strong>
                        </v-flex>
                        <v-flex xs12>
                          <v-menu
                            ref="menu"
                            v-model="menuDate"
                            :close-on-content-click="false"
                            :return-value.sync="formData.membershipListingDate"
                            lazy
                            transition="scale-transition"
                            offset-y
                            full-width
                            min-width="290px"
                          >
                            <template slot="activator">
                              <v-text-field
                                v-model="formData.membershipListingDate"
                                label="Membership Listing Date"
                                :disabled="!userData.role.includes('Admin')"
                                prepend-icon="mdi-calendar"
                                readonly
                              />
                            </template>
                            <v-date-picker
                              v-model="formData.membershipListingDate"
                              no-title
                              scrollable
                            >
                              <v-spacer />
                              <v-btn
                                flat
                                color="primary"
                                @click="menuDate = false"
                                >Cancel</v-btn
                              >
                              <v-btn
                                flat
                                color="primary"
                                @click="
                                  $refs.menu.save(
                                    formData.membershipListingDate
                                  )
                                "
                                >OK</v-btn
                              >
                            </v-date-picker>
                          </v-menu>
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field
                            v-model="formData.listTitle"
                            :disabled="!userData.role.includes('Admin')"
                            :rules="[(v) => !!v || 'Listing title is required']"
                            hint="Short title of who you are or what you do for example 'Builder'."
                            counter="50"
                            maxlength="50"
                            label="Listing Title"
                            required
                          />
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field
                            :disabled="!userData.role.includes('Admin')"
                            v-model="formData.urlKeyword"
                            hint="This will be used to redirect urls like 'www.upstream.co.nz/buy/__"
                            label="URL Keyword"
                          />
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field
                            :disabled="!userData.role.includes('Admin')"
                            v-model="formData.name"
                            :rules="[(v) => !!v || 'Name is required']"
                            label="Business Name"
                            required
                          />
                        </v-flex>
                        <v-flex xs6>
                          <v-text-field
                            :disabled="!userData.role.includes('Admin')"
                            v-model="formData.ownerName"
                            label="Owners name (not public)"
                          />
                        </v-flex>
                        <v-flex xs6>
                          <v-text-field
                            :disabled="!userData.role.includes('Admin')"
                            v-model="formData.ownerContactPerson"
                            label="Owners Contact Person (not public)"
                          />
                        </v-flex>
                        <v-flex xs6>
                          <v-text-field
                            v-model="formData.ownerEmail"
                            label="Email of Owner (not public)"
                          />
                        </v-flex>
                        <v-flex xs6>
                          <v-text-field
                            :disabled="!userData.role.includes('Admin')"
                            v-model="formData.introsEmail"
                            label="Intros Email (not public)"
                          />
                        </v-flex>
                        <v-flex xs6>
                          <v-text-field
                            v-model="formData.ownerMobile"
                            label="Mobile of Owner (not public)"
                          />
                        </v-flex>
                        <v-flex xs6>
                          <v-text-field
                            :disabled="!userData.role.includes('Admin')"
                            v-model="formData.invoiceEmail"
                            label="Email for Invoicing (not public)"
                          />
                        </v-flex>
                        <v-flex xs6>
                          <v-text-field
                            v-model="formData.email"
                            :rules="[(v) => !!v || 'Email is required']"
                            label="E-mail for enquiries (not public)"
                            required
                          />
                        </v-flex>
                        <v-flex xs6>
                          <v-text-field
                            :disabled="!userData.role.includes('Admin')"
                            v-model="formData.paperDirectoryEmailAlias"
                            label="Paper directory E-mail alias"
                          />
                        </v-flex>
                        <v-flex xs6>
                          <v-text-field
                            :disabled="!userData.role.includes('Admin')"
                            v-model="formData.callRailPhone"
                            hide-details
                            label="Call Tracking Number"
                          />
                        </v-flex>
                        <v-flex xs6>
                          <v-text-field
                            :disabled="!userData.role.includes('Admin')"
                            v-model="formData.callTrackingForwardNumber"
                            hide-details
                            label="Call Tracking Forwarding To This Number"
                          />
                        </v-flex>
                        <v-flex xs6>
                          <v-select
                            :disabled="!userData.role.includes('Admin')"
                            v-model="formData.callTrackingTitleOfPerson"
                            :items="['Owner-Operator', 'Salesperson', 'Office']"
                            label="Call Tracking Title of Person"
                            placeholder="Please select"
                          />
                        </v-flex>
                        <v-flex xs6>
                          <v-select
                            :disabled="!userData.role.includes('Admin')"
                            v-model="formData.category"
                            :items="categories"
                            item-text="name"
                            item-value="id"
                            label="Category"
                            placeholder="Please select"
                            multiple
                            chips
                            attach
                          />
                        </v-flex>
                        <v-flex xs6>
                          <v-select
                            v-if="formData.category"
                            v-model="formData.subCategory"
                            :items="subCategoryOptions()"
                            item-text="name"
                            item-value="id"
                            label="Subcategory"
                            placeholder="Please select"
                            :disabled="!userData.role.includes('Admin')"
                            multiple
                            attach
                            chips
                          />
                        </v-flex>
                        <v-flex xs6>
                          <v-select
                            v-model="formData.contribution"
                            :items="[
                              '%',
                              '% of specific',
                              'Fixed cost',
                              'Range',
                            ]"
                            label="Charitable contribution"
                            :disabled="!userData.role.includes('Admin')"
                            placeholder="Please select"
                          />
                        </v-flex>
                        <v-flex xs6>
                          <v-text-field
                            :disabled="!userData.role.includes('Admin')"
                            v-model="formData.contributionDetails"
                            label="Contribution details (shown on website)"
                            counter="35"
                            maxlength="35"
                            :rules="[
                              (v) =>
                                v.length <= 35 ||
                                'Maximum of 35 characters allowed.',
                            ]"
                          />
                        </v-flex>
                        <v-flex xs6>
                          <v-text-field
                            v-model="formData.website"
                            hide-details
                            label="Website (not public)"
                          />
                        </v-flex>
                        <v-flex xs6>
                          <v-text-field
                            :disabled="!userData.role.includes('Admin')"
                            v-model="formData.membershipOption"
                            label="Membership Option & Payment Frenquency"
                            counter="100"
                            maxlength="100"
                            :rules="[
                              (v) =>
                                v.length <= 35 ||
                                'Maximum of 35 characters allowed.',
                            ]"
                          />
                        </v-flex>
                        <v-flex xs12>
                          <strong
                            >Physical Address we courier items to (not
                            public)</strong
                          >
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field
                            v-model="formData.physicalAddress"
                            hide-details
                            label="Address"
                          />
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field
                            v-model="formData.physicalSuburb"
                            hide-details
                            label="Suburb"
                          />
                        </v-flex>
                        <v-flex xs6>
                          <v-text-field
                            v-model="formData.physicalCity"
                            hide-details
                            label="City"
                          />
                        </v-flex>
                        <v-flex xs6>
                          <v-text-field
                            v-model="formData.physicalPostCode"
                            hide-details
                            label="Postcode"
                          />
                        </v-flex>
                        <v-flex xs12>
                          <strong
                            >Postal Address we post envelopes to (not
                            public)</strong
                          >
                          <v-checkbox
                            v-model="formData.postalAsAbove"
                            label="As above"
                          />
                        </v-flex>
                        <template
                          v-if="formData.postalAsAbove !== true"
                          width="100%"
                        >
                          <v-flex xs12>
                            <v-text-field
                              v-model="formData.postalAddress"
                              hide-details
                              label="Address"
                            />
                          </v-flex>
                          <v-flex xs12>
                            <v-text-field
                              v-model="formData.postalSuburb"
                              hide-details
                              label="Suburb"
                            />
                          </v-flex>
                          <v-flex xs6>
                            <v-text-field
                              v-model="formData.postalCity"
                              hide-details
                              label="City"
                            />
                          </v-flex>
                          <v-flex xs6>
                            <v-text-field
                              v-model="formData.postalPostCode"
                              hide-details
                              label="Postcode"
                            />
                          </v-flex>
                        </template>
                        <v-flex v-if="userData.role.includes('Admin')" xs6>
                          <v-select
                            v-model="formData.status"
                            :items="[
                              'Admin',
                              'Prospecting',
                              'Pending',
                              'Approved',
                              'Suspended',
                            ]"
                            label="Status"
                            placeholder="Please select"
                          />
                        </v-flex>
                        <v-flex v-if="userData.role.includes('Admin')" xs6>
                          <v-text-field
                            v-model="formData.searchWeight"
                            hide-details
                            label="Search Weight"
                          />
                        </v-flex>
                      </v-layout>
                    </v-form>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item>
                <v-card flat>
                  <v-card-text>
                    <v-form ref="profileForm">
                      <v-layout key="profile" wrap justify-center>
                        <v-flex xs12 class="autoMargin">
                          <span class="subheading"
                            >Profile Picture (Landscape orientation
                            preferred)</span
                          >
                          <div v-if="formData.imageUrl">
                            <v-img
                              :src="formData.imageUrl"
                              :width="300"
                              :height="200"
                              class="autoMargin"
                            />
                            <v-btn
                              small
                              block
                              color="info"
                              @click="changeImage = true"
                              >Change Image</v-btn
                            >
                          </div>
                          <croppa
                            v-if="!formData.imageUrl || changeImage"
                            v-model="image"
                            :show-loading="true"
                            :width="300"
                            :height="200"
                            :quality="2"
                            canvas-color="#FFF"
                            placeholder-color="#000000"
                            placeholder="Choose profile image"
                            style="width: 300px"
                            initial-size="contain"
                          />
                          <div
                            v-if="!formData.imageUrl || changeImage"
                            class="caption text-xs-center"
                          >
                            Use scroll wheel to zoom in / out and drag to
                            reposition.
                          </div>
                        </v-flex>
                        <v-flex xs12>
                          <v-textarea
                            v-model="formData.whoAreWe"
                            :rules="[rules.max500]"
                            label="Who are we"
                            counter="500"
                            maxlength="500"
                          />
                        </v-flex>
                        <v-flex xs12>
                          <v-textarea
                            v-model="formData.aboutWhatWeDo"
                            :rules="[rules.max500]"
                            label="About what we do"
                            counter="500"
                            maxlength="500"
                          />
                        </v-flex>
                        <v-flex xs12>
                          <v-textarea
                            v-model="formData.paperDirectoryListing"
                            :rules="[rules.max180]"
                            label="Notes"
                            counter="180"
                            maxlength="180"
                            @change="updatePaperDirectoryChanged()"
                          />
                        </v-flex>
                        <v-flex v-if="userData.role.includes('Admin')" xs12>
                          <strong>
                            Last updated:
                            {{ formData.paperDirectoryLastChanged }}
                          </strong>
                        </v-flex>
                      </v-layout>
                    </v-form>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item>
                <v-card flat>
                  <v-card-text>
                    <div class="title">
                      Provide a list of services your business offers under each
                      sub category
                    </div>
                    <div class="caption">
                      Add the services that your business offers
                      <br />ONLY services that are already loaded by UpstreamNZ
                      admin will show - we do this so we never have a NO RESULTS
                      page <br />If a service you are looking for doesn't appear
                      please fill
                      <a
                        href="https://docs.google.com/forms/d/e/1FAIpQLSeJS-ileUr7uTJJ7h7oiU-3N8Qx1WKbrb3RVNpmSwc9cO-YBQ/viewform"
                        >this form</a
                      >
                      to request it.
                      <br />Click on the end of the list to add a new item.
                      <br />
                      <strong>
                        The first set of services will be displayed publically
                        on your profile. The second set will only be used as
                        additional key words in searches.
                      </strong>
                    </div>
                    <v-layout key="services" wrap justify-center>
                      <v-flex xs12>
                        <v-combobox
                          v-if="formData.id === '32'"
                          v-model="formData.services"
                          :items="services"
                          hide-selected
                          chips
                          color="blue lighten-2"
                          label="Enter services"
                          multiple
                          deletable-chips
                        />
                      </v-flex>
                      <v-flex xs12>
                        <v-autocomplete
                          v-if="formData.id !== '32'"
                          v-model="formData.services"
                          :items="services"
                          hide-selected
                          chips
                          color="blue lighten-2"
                          label="What You Offer"
                          hint="Enter services you offer that will be displayed on your listing profile"
                          multiple
                          deletable-chips
                          persistent-hint
                        />
                      </v-flex>
                      <v-flex xs12>
                        <v-autocomplete
                          v-if="formData.id !== '32'"
                          v-model="formData.searchServices"
                          :items="services"
                          hide-selected
                          chips
                          color="blue lighten-2"
                          label="What Your Are / Other Keywords"
                          hint="Enter additional services or keywords that will be used in searches. These won't be displayed on your listing profile, but the customer searches these words, your listing will show as a result"
                          multiple
                          deletable-chips
                          persistent-hint
                        />
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <!-- TAB : OUR WORK -->
              <v-tab-item>
                <v-btn color="info" @click="openWorkDialog({ idx: -1 })"
                  >Add Work Example</v-btn
                >
                <v-dialog
                  v-model="workItemDialog"
                  persistent
                  max-width="1000px"
                >
                  <v-card>
                    <v-card-text>
                      <v-radio-group v-model="workItem.type">
                        <v-radio
                          label="Image (PNG and JPEG Only)"
                          value="image"
                        />
                        <v-radio
                          label="Video (Youtube Urls Only)"
                          value="video"
                        />
                      </v-radio-group>
                      <div v-if="workItem.type == 'image'" class="subheading">
                        Provide a picture of the work done and a short
                        description
                      </div>
                      <v-container grid-list-md v-if="workItem.type == 'image'">
                        <v-layout row>
                          <div style="flex: 1">
                            <v-flex xs12>
                              <v-text-field
                                v-model="workItem.description"
                                label="Description"
                                counter="100"
                                maxlength="100"
                              />
                            </v-flex>
                            <small
                              v-if="!workItem.imageUrl || changeWorkItemImage"
                            >
                              Actual image will be twice this size
                              <br />Use scroll wheel to zoom in / out and drag
                              to reposition.
                            </small>
                            <v-radio-group
                              v-if="!workItem.imageUrl || changeWorkItemImage"
                              v-model="workItem.imageOrientation"
                            >
                              <v-radio
                                v-for="n in ['Portrait', 'Landscape']"
                                :key="n"
                                :label="n"
                                :value="n"
                              />
                            </v-radio-group>
                          </div>
                          <div style="flex: 1">
                            <v-flex xs12>
                              <div
                                v-if="workItem.imageUrl && !changeWorkItemImage"
                              >
                                <v-img
                                  :src="workItem.imageUrl"
                                  :width="
                                    workItem.imageOrientation == 'Landscape'
                                      ? 400
                                      : 300
                                  "
                                  :height="
                                    workItem.imageOrientation == 'Landscape'
                                      ? 300
                                      : 400
                                  "
                                  class="autoMargin"
                                />
                                <v-btn
                                  small
                                  block
                                  color="info"
                                  @click="changeWorkItemImage = true"
                                  >Change Image</v-btn
                                >
                              </div>
                              <croppa
                                v-if="!workItem.imageUrl || changeWorkItemImage"
                                v-model="workItemImage"
                                :show-loading="true"
                                :width="
                                  workItem.imageOrientation == 'Landscape'
                                    ? 400
                                    : 300
                                "
                                :height="
                                  workItem.imageOrientation == 'Landscape'
                                    ? 300
                                    : 400
                                "
                                :quality="2"
                                :style="`width:${
                                  workItem.imageOrientation == 'Landscape'
                                    ? 400
                                    : 300
                                }px`"
                                canvas-color="#FFF"
                                placeholder-color="#000000"
                                placeholder="Choose profile image"
                                initial-size="contain"
                              />
                            </v-flex>
                          </div>
                        </v-layout>
                      </v-container>
                      <v-container grid-list-md v-if="workItem.type == 'video'">
                        <v-layout row>
                          <div style="flex: 1">
                            <v-flex xs12>
                              <v-text-field
                                v-model="workItem.description"
                                label="Description"
                                counter="100"
                                maxlength="100"
                              />
                            </v-flex>
                            <v-flex xs12>
                              <v-text-field
                                v-model="workItem.videoUrl"
                                label="Video Url"
                              />
                            </v-flex>
                          </div>
                        </v-layout>
                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer />
                      <v-btn
                        color="blue darken-1"
                        flat
                        @click="workItemDialog = false"
                        >Close</v-btn
                      >
                      <v-btn
                        :loading="saving"
                        v-if="workItem.type == 'image'"
                        color="success"
                        @click="saveWorkItem()"
                        >Save</v-btn
                      >
                      <v-btn
                        :loading="saving"
                        v-if="workItem.type == 'video'"
                        color="success"
                        @click="saveWorkItemVideo()"
                        >Save</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <v-card flat>
                  <v-card-text>
                    <v-layout key="ourWork" wrap justify-center>
                      <v-flex
                        v-for="(work, index) in formData.ourWork"
                        :key="`work_${index}`"
                        xs6
                        sm4
                      >
                        <v-card>
                          <v-img
                            v-if="work.imageUrl"
                            :src="work.imageUrl"
                            height="200px"
                          >
                            <v-container fill-height fluid pa-2>
                              <v-layout fill-height>
                                <v-flex xs12 align-end flexbox />
                              </v-layout>
                            </v-container>
                          </v-img>
                          <silentbox-single v-else :src="work.videoUrl">
                            <v-img
                              height="200px"
                              :src="`https://img.youtube.com/vi/${work.videoID}/hqdefault.jpg`"
                            >
                              <v-container fill-height fluid pa-2>
                                <v-layout fill-height>
                                  <v-flex xs12 align-end flexbox />
                                </v-layout>
                              </v-container>
                            </v-img>
                          </silentbox-single>
                          <v-card-title primary-title>
                            <div>
                              <span>{{ work.description }}</span>
                            </div>
                          </v-card-title>
                          <v-card-actions>
                            <v-spacer />
                            <v-btn
                              icon
                              @click="
                                work.idx = index;
                                openWorkDialog(work);
                              "
                            >
                              <v-icon color="blue">mdi-pencil</v-icon>
                            </v-btn>
                            <v-btn icon @click="deleteWorkItem(work)">
                              <v-icon color="red">mdi-delete</v-icon>
                            </v-btn>
                          </v-card-actions>
                          <v-card-actions>
                            <v-btn
                              v-if="index !== 0"
                              icon
                              @click="moveUp(index)"
                            >
                              <v-icon color="blue">mdi-chevron-left</v-icon>
                            </v-btn>
                            <v-spacer />
                            <v-btn
                              v-if="index !== formData.ourWork.length - 1"
                              icon
                              @click="moveDown(index)"
                            >
                              <v-icon color="blue">mdi-chevron-right</v-icon>
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <!-- Testimonials -->
              <v-tab-item>
                <v-dialog
                  v-model="testimonialDialogBox"
                  persistent
                  max-width="1000px"
                >
                  <v-card>
                    <v-card-text>
                      <v-container grid-list-md>
                        <v-layout row>
                          <div style="flex: 1">
                            <v-flex xs12>
                              <v-textarea
                                v-model="testimonialItem.message"
                                label="Description"
                                counter="225"
                                maxlength="225"
                              />
                            </v-flex>
                            <v-flex xs12>
                              <v-checkbox
                                v-if="!testimonialItem.featured"
                                v-model="testimonialItem.visible"
                                label="Visible"
                              />
                              <v-checkbox
                                v-else
                                v-model="testimonialItem.visible"
                                disabled
                                label="Visible"
                              />
                              <v-checkbox
                                v-model="testimonialItem.featured"
                                @change="featuredTestimonial()"
                                label="Featured"
                              />
                            </v-flex>
                          </div>
                        </v-layout>
                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer />
                      <v-btn
                        color="blue darken-1"
                        flat
                        @click="testimonialDialogBox = false"
                        >Close</v-btn
                      >
                      <v-btn
                        :loading="saving"
                        color="success"
                        @click="saveTestimonialItem()"
                        >Save</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <v-card flat>
                  <v-card-text>
                    <v-layout key="testimonial" wrap justify-center>
                      <v-flex
                        v-for="(testimonial, index) in formData.testimonial"
                        :key="`testimonial_${index}`"
                        xs6
                        sm4
                      >
                        <v-card>
                          <v-card-title primary-title>
                            <div>
                              {{ testimonial.fullName }}
                              <v-icon
                                v-if="
                                  testimonial.visible || testimonial.featured
                                "
                                color="blue"
                                >mdi-eye</v-icon
                              >
                              <v-icon v-else color="blue">mdi-eye-off</v-icon>
                              <v-icon v-if="testimonial.featured" color="yellow"
                                >mdi-star</v-icon
                              >
                            </div>
                          </v-card-title>
                          <v-card-text>
                            <div>
                              <span>{{ testimonial.message }}</span>
                            </div>
                          </v-card-text>
                          <v-card-actions>
                            <v-spacer />
                            <v-btn
                              icon
                              @click="
                                testimonial.idx = index;
                                openTestimonialDialog(testimonial);
                              "
                            >
                              <v-icon color="blue">mdi-pencil</v-icon>
                            </v-btn>
                            <v-btn icon @click="deleteTestimonial(testimonial)">
                              <v-icon color="red">mdi-delete</v-icon>
                            </v-btn>
                          </v-card-actions>
                          <!-- <v-card-actions>
                            <v-btn v-if="index !== 0" icon @click="testimonialMoveUp(index)">
                              <v-icon color="blue">mdi-chevron-left</v-icon>
                            </v-btn>
                            <v-spacer />
                            <v-btn
                              v-if="index !== (formData.testimonial.length - 1)"
                              icon
                              @click="testimonialMoveDown(index)"
                            >
                              <v-icon color="blue">mdi-chevron-right</v-icon>
                            </v-btn>
                          </v-card-actions>-->
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <!-- Product Details Area -->
              <v-tab-item v-if="userData.role.includes('Admin')">
                <v-card flat>
                  <v-card-text>
                    <v-form ref="businessForm">
                      <v-layout key="form" wrap justify-center>
                        <v-flex xs12>
                          <strong>ID: {{ formData.id }}</strong>
                        </v-flex>
                        <v-flex xs12 class="py-0">
                          <strong>Affiliate Tracking Options.</strong>
                        </v-flex>
                        <v-flex xs12 md6>
                          <v-checkbox
                            v-model="formData.emailButtonVisible"
                            label="Show Email Button"
                          />
                        </v-flex>
                        <v-flex
                          v-if="formData.emailButtonVisible"
                          xs12
                          class="py-0"
                        >
                          <strong>Email Button Settings.</strong>
                        </v-flex>
                        <v-flex v-if="formData.emailButtonVisible" xs6>
                          <v-text-field
                            v-model="formData.buttonText"
                            hide-details
                            label="Button Text"
                          />
                        </v-flex>
                        <v-flex v-if="formData.emailButtonVisible" xs6>
                          <v-text-field
                            v-model="formData.buttonSubText"
                            hide-details
                            label="Button sub-text (displayed below button)"
                          />
                        </v-flex>
                        <v-flex v-if="formData.emailButtonVisible" xs12>
                          <v-text-field
                            v-model="formData.buttonLink"
                            hide-details
                            label="Button Link"
                          />
                        </v-flex>
                        <v-flex xs12 md6>
                          <v-checkbox
                            v-model="formData.affiliateButtonVisible"
                            label="Show Affiliate Link Button"
                          />
                        </v-flex>

                        <v-flex
                          v-if="formData.affiliateButtonVisible"
                          xs12
                          class="py-0"
                        >
                          <strong>Affiliate Link Button Settings.</strong>
                        </v-flex>
                        <v-flex v-if="formData.affiliateButtonVisible" xs6>
                          <v-text-field
                            v-model="formData.affiliateButtonText"
                            hide-details
                            label="Affiliate Button Text"
                          />
                        </v-flex>
                        <v-flex v-if="formData.affiliateButtonVisible" xs6>
                          <v-text-field
                            v-model="formData.affiliateButtonSubText"
                            hide-details
                            label="Affiliate Button sub-text (displayed below button)"
                          />
                        </v-flex>
                        <v-flex v-if="formData.affiliateButtonVisible" xs12>
                          <v-text-field
                            v-model="formData.affiliateButtonLink"
                            hide-details
                            label="Affiliate Button Link"
                          />
                        </v-flex>
                        <v-flex xs12 md6>
                          <v-checkbox
                            v-model="formData.useContactForm"
                            label="Use contact form when linking to affiliate site"
                          />
                        </v-flex>
                        <v-flex xs12 md6>
                          <v-checkbox
                            v-model="formData.emailNotificationsDisabled"
                            label="Do not send email notifications to this supplier"
                          />
                        </v-flex>
                        <v-flex v-if="formData.useContactForm" xs12>
                          <v-text-field
                            v-model="formData.contactUsHeader"
                            hide-details
                            label="Heading for contact form."
                            placeholder="Contact Us"
                          />
                        </v-flex>
                        <v-flex v-if="formData.useContactForm" xs12>
                          <v-text-field
                            v-model="formData.contactUsSubheading"
                            hide-details
                            label="Sub heading for contact form."
                            placeholder="We are sending you to this business' website via an affiliate link that lets them know you came from Upstream so your Good Cause will receive their contribution. Thanks for your support."
                          />
                        </v-flex>

                        <v-flex xs12 class="py-0">
                          <strong>Listing Title Options.</strong>
                        </v-flex>

                        <v-flex xs6>
                          <v-text-field
                            v-model="formData.servicesHeadingOverride"
                            hide-details
                            label="Our services override heading"
                          />
                        </v-flex>
                        <v-flex xs6>
                          <v-text-field
                            v-model="formData.ourWorkHeadingOverride"
                            hide-details
                            label="Our work override heading"
                          />
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field
                            v-model="formData.emailFileDescription"
                            hide-details
                            label="Description shown for email file upload. File upload will show if this is not empty."
                          />
                        </v-flex>
                      </v-layout>
                    </v-form>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item v-if="userData.role.includes('Admin')">
                <v-card flat>
                  <v-card-text>
                    <v-form ref="businessForm">
                      <v-layout key="form" wrap justify-center>
                        <v-flex xs12>
                          <strong>ID: {{ formData.id }}</strong>
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field
                            v-model="formData.desktopUrl"
                            hide-details
                            label="Desktop URL"
                          />
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field
                            v-model="formData.mobilUrl"
                            hide-details
                            label="Mobile URL"
                          />
                        </v-flex>
                        <v-flex xs12>
                          <v-text-field
                            v-model="formData.destinationUrl"
                            hide-details
                            label="Destination URL"
                          />
                        </v-flex>
                        <v-flex xs12>
                          <v-btn
                            @click="
                              promotionFileChangeChoice = 'Desktop';
                              changePromotionFileDialog = true;
                            "
                            color="primary"
                            >Change Desktop Image</v-btn
                          >
                          <v-btn
                            @click="
                              promotionFileChangeChoice = 'Mobile';
                              changePromotionFileDialog = true;
                            "
                            color="primary"
                            >Change Mobile Image</v-btn
                          >
                          <v-btn
                            @click="
                              promotionFileChangeChoice = 'Destination';
                              changePromotionFileDialog = true;
                            "
                            color="primary"
                            >Upload Destination File</v-btn
                          >
                        </v-flex>
                        <v-flex xs12>
                          <v-checkbox
                            v-model="formData.promotionLive"
                            label="Make this promotion live"
                          />
                        </v-flex>
                        <v-flex v-if="formData.desktopUrl" xs12 sm6>
                          <h3>Desktop Image</h3>
                          <v-img
                            :src="formData.desktopUrl"
                            class="autoMargin"
                          />
                        </v-flex>
                        <v-flex v-if="formData.mobilUrl" xs12 sm6>
                          <h3>Mobile Image</h3>
                          <v-img :src="formData.mobilUrl" class="autoMargin" />
                        </v-flex>
                      </v-layout>
                    </v-form>
                  </v-card-text>
                </v-card>
                <v-dialog
                  v-model="changePromotionFileDialog"
                  persistent
                  max-width="1000px"
                >
                  <v-card>
                    <v-card-title>Upload File</v-card-title>
                    <v-card-text>
                      <input type="file" @change="fileChange" />
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer />
                      <v-btn
                        color="blue darken-1"
                        flat
                        @click="changePromotionFileDialog = false"
                        >Close</v-btn
                      >
                      <v-btn
                        :loading="saving"
                        color="success"
                        @click="uploadPromotionFile()"
                        >Save</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-tab-item>
              <v-tab-item v-if="userData.role.includes('Admin')">
                <v-btn
                  color="info"
                  @click="
                    promotionFileChangeChoice = 'LearnMore';
                    openLearnMoreDialog({ idx: -1 });
                  "
                  >Add Learn More File Download</v-btn
                >
                <v-card flat>
                  <v-card-text>
                    <v-form ref="businessForm">
                      <v-layout key="form" wrap justify-center>
                        <v-flex xs12>
                          <strong>ID: {{ formData.id }}</strong>
                        </v-flex>
                        <v-flex
                          v-for="(learnMore, index) in formData.learnMore"
                          :key="`learnMore_${index}`"
                          xs6
                          sm4
                        >
                          <v-card>
                            <v-card-title primary-title>
                              <div>{{ learnMore.title }}</div>
                            </v-card-title>
                            <v-card-text>
                              <a target="_blank" :href="learnMore.fileLink"
                                >Click Here for File</a
                              >
                            </v-card-text>
                            <v-card-actions>
                              <!-- Tally indicator -->
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                  <p
                                    class="font-weight-medium"
                                    style="color: #4cc7e8"
                                    v-on="on"
                                  >
                                    {{ learnMoreTallyClicks(learnMore.id) }}
                                    <v-icon
                                      style="font-size: 17px; color: #4cc7e8"
                                      >mdi-download</v-icon
                                    >
                                  </p>
                                </template>
                                <span
                                  >Amount of times this has been
                                  Downloaded</span
                                >
                              </v-tooltip>
                              <v-spacer />
                              <v-btn
                                icon
                                @click="openLearnMoreDialog(learnMore)"
                              >
                                <v-icon color="blue">mdi-pencil</v-icon>
                              </v-btn>
                              <v-btn icon @click="deleteLearnMore(learnMore)">
                                <v-icon color="red">mdi-delete</v-icon>
                              </v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-flex>
                      </v-layout>
                    </v-form>
                  </v-card-text>
                </v-card>
                <v-dialog
                  v-model="learnMoreDialogBox"
                  persistent
                  max-width="1000px"
                >
                  <v-card>
                    <v-card-title>Learn More File Download</v-card-title>
                    <v-card-text>
                      <v-text-field
                        style="padding: 10px"
                        v-model="learnMoreItem.title"
                        hide-details
                        label="Title"
                      />
                      <input type="file" @change="fileChange" />
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer />
                      <v-btn
                        color="blue darken-1"
                        flat
                        @click="learnMoreDialogBox = false"
                        >Close</v-btn
                      >
                      <v-btn
                        :loading="saving"
                        color="success"
                        @click="saveLearnMoreItem()"
                        >Save</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-tab-item>
              <!--This is the location form-->
              <v-tab-item v-if="userData.role.includes('Admin')">
                <v-card flat>
                  <v-card-text>
                    <v-form autocomplete="off" ref="businessForm">
                      <v-layout key="form" wrap justify-center>
                        <v-flex xs12>
                          <strong>ID: {{ formData.id }}</strong>
                        </v-flex>
                        <v-flex xs12>
                          <h3>
                            Select what regions and districts you are able to
                            service:
                          </h3>
                        </v-flex>
                        <v-flex xs12>
                          <v-combobox
                            ref="selectRegionInput"
                            id="selectRegionInput"
                            autocomplete="new-password"
                            v-model="selectRegion"
                            :items="regions"
                            label="Select Region"
                            multiple
                            chips
                          ></v-combobox>
                        </v-flex>
                        <v-flex xs12>
                          <v-combobox
                            ref="selectCityInput"
                            id="selectCityInput"
                            autocomplete="new-password"
                            v-model="selectCity"
                            :items="cities"
                            :disabled="selectRegion.includes('Nationwide')"
                            label="Select City"
                            multiple
                            chips
                          ></v-combobox>
                        </v-flex>
                        <v-flex xs12>
                          <h3>Office locations</h3>
                          <p>
                            Begin typing your office address and then select the
                            correct address from the list that appears and click
                            <strong>"Add Location"</strong>:
                          </p>
                        </v-flex>
                        <v-flex xs12>
                          <vue-google-autocomplete
                            ref="addressInput"
                            id="map googleInput"
                            class="form-control"
                            placeholder="Enter Address..."
                            country="nz"
                            v-on:placechanged="getAddressData"
                            autocomplete="off"
                          ></vue-google-autocomplete>
                          <v-btn flat icon color="green" @click="addLocation()">
                            <v-icon>mdi-plus</v-icon>
                          </v-btn>
                        </v-flex>
                      </v-layout>
                      <v-flex d-flex>
                        <v-layout wrap>
                          <v-flex
                            lg4
                            md4
                            xs12
                            sm6
                            v-for="(location, idx) in locations"
                            :key="location"
                          >
                            <v-card>
                              <v-card-title primary-title>
                                {{ location }}
                              </v-card-title>
                              <v-card-actions>
                                <v-spacer></v-spacer>

                                <v-btn
                                  icon
                                  @click="removeLocation(location, idx)"
                                  color="red"
                                >
                                  <v-icon color="white">mdi-delete</v-icon>
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-form>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <!--This is the location form-->
            </v-tabs>
            <v-layout row class="pl-3 pr-3">
              <v-btn
                v-if="activeTab != 3"
                @click="save()"
                :loading="saving"
                color="success"
                >Save</v-btn
              >
            </v-layout>
          </v-sheet>
          <v-data-table
            v-else
            key="list"
            :headers="headers"
            :items="businesses"
            :search="searchSuppliers"
            hide-actions
          >
            <template slot="headerCell" slot-scope="{ header }">
              <span
                class="subheading font-weight-light text--darken-3"
                style="color: #4cc7e8"
                v-text="header.text"
              />
            </template>
            <template slot="items" slot-scope="{ item }">
              <td>{{ item.id }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.listTitle }}</td>
              <td>{{ item.status }}</td>
              <td>
                <p v-if="typeof item.testimonial != 'undefined'">
                  {{ item.testimonial.length }}
                </p>
              </td>
              <td>{{ item.membershipListingDate }}</td>
              <td class="action-col" width="20">
                <v-btn flat icon @click="open(item, item.id)">
                  <v-icon color="blue">mdi-folder-outline</v-icon>
                </v-btn>
              </td>
            </template>
          </v-data-table>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import { mapGetters } from "vuex";
  import VueGoogleAutocomplete from "vue-google-autocomplete";

  export default {
    components: { VueGoogleAutocomplete },
    data: () => ({
      address: "",
      rules: {
        max400: (value) => !value || value.length <= 400 || "Max 400 characters",
        max500: (value) => !value || value.length <= 500 || "Max 500 characters",
        max600: (value) => !value || value.length <= 600 || "Max 600 characters",
        max180: (value) => !value || value.length <= 180 || "Max 180 characters",
      },
      testimonialDialogBox: false,
      selectCity: [],
      selectRegion: [],
      locations: [],
      fullLocationData: [],
      regions: [
        "Nationwide",
        "Auckland",
        "Bay Of Plenty",
        "Canterbury",
        "Gisborne",
        "Hawke's Bay",
        "Manawatu/Whanganui",
        "Marlborough",
        "Nelson/Tasman",
        "Northland",
        "Otago",
        "Southland",
        "Taranaki",
        "Waikato",
        "Wellington",
        "West Coast",
      ],
      cities: [
        "Far North",
        "Kaipara",
        "Whangarei",
        "Auckland City",
        "Franklin",
        "Hauraki Gulf Islands",
        "Manukau City",
        "North Shore City",
        "Papakura",
        "Rodney",
        "Waiheke Island",
        "Waitakere City",
        "Hamilton",
        "Hauraki",
        "Matamata-Piako",
        "Otorohanga",
        "South Waikato",
        "Taupo",
        "Thames-Coromandel",
        "Waikato",
        "Waipa",
        "Waitomo",
        "Kawerau",
        "Opotiki",
        "Rotorua",
        "Tauranga",
        "Western Bay Of Plenty",
        "Whakatane",
        "Gisborne",
        "Central Hawke's Bay",
        "Hastings",
        "Napier",
        "Wairoa",
        "New Plymouth",
        "South Taranaki",
        "Stratford",
        "Horowhenua",
        "Manawatu",
        "Palmerston North",
        "Rangitikei",
        "Ruapehu",
        "Tararua",
        "Whanganui",
        "Carterton",
        "Kapiti Coast",
        "Lower Hutt",
        "Masterton",
        "Porirua",
        "South Wairarapa",
        "Upper Hutt",
        "Wellington",
        "Nelson",
        "Tasman",
        "Blenheim",
        "Kaikoura",
        "Marlborough",
        "Buller",
        "Grey",
        "Westland",
        "Ashburton",
        "Banks Peninsula",
        "Christchurch City",
        "Hurunui",
        "Mackenzie",
        "Selwyn",
        "Timaru",
        "Waimakariri",
        "Waimate",
        "Central Otago",
        "Clutha",
        "Dunedin",
        "Queenstown-Lakes",
        "South Otago",
        "Waitaki",
        "Wanaka",
        "Catlins",
        "Gore",
        "Invercargill",
        "Southland",
      ],
      testimonialItem: {},
      learnMoreItem: {},
      learnMoreDialogBox: false,
      menuDate: false,
      menuDateOn: false,
      deleting: false,
      workOptions: [
        { val: "image", label: "Image (PNG and JPEG Only)" },
        { val: "video", label: "Video (Youtube Urls Only)" },
      ],
      promotionFileChangeChoice: "",
      changePromotionFileDialog: false,
      fileData: {},
      includeFileData: false,
      imageOrientation: "Landscape",
      workItemDialog: false,
      changeWorkItemImage: false,
      workItem: {},
      image: null,
      workItemImage: null,
      changeImage: false,
      activeTab: null,
      saving: false,
      formOpen: false,
      formData: {},
      searchSuppliers: "",
      headers: [
        {
          sortable: true,
          text: "ID",
          value: "id",
        },
        {
          sortable: true,
          text: "Supplier Name",
          value: "name",
        },
        {
          sortable: true,
          text: "Listing Title",
          value: "listTitle",
        },
        {
          sortable: true,
          text: "Status",
          value: "status",
        },
        {
          sortable: false,
          text: "Testimonial #",
          value: "testimonial",
        },
        {
          sortable: true,
          text: "Membership Date",
          value: "membershipListingDate",
        },
        {
          sortable: false,
          text: "",
          value: "action",
        },
      ],
    }),
    computed: {
      ...mapGetters({
        user: "user",
        userData: "user/userData",
        businesses: "business/list",
        services: "business/services",
        categories: "categories/list",
        categoriesByName: "categories/byName",
        tally: "clicks/tallyData",
      }),
    },
    created() {
      this.$nextTick(function () {
        this.$store.dispatch("business/loadAllAdmin").then(() => {
          this.loadTestimonialById();
        });
        this.$store.dispatch("clicks/loadClickTally").then(() => {});
      });
    },
    mounted() {},
    methods: {
      /**
       * When the location found
       * @param {Object} addressData Data of the found location
       * @param {Object} placeResultData PlaceResult object
       * @param {String} id Input container ID
       */
      getAddressData: function (addressData, placeResultData, id) {
        this.address = placeResultData;
      },
      addLocation() {
        this.locations.push(this.address["address_components"][2]["long_name"]);
        this.fullLocationData.push(this.address);
      },
      removeLocation(data, idx) {
        this.locations.splice(idx, 1);
      },
      subCategoryOptions() {
        let subList = [];
        if (typeof this.formData.category == "object") {
          this.formData.category.forEach((cat) => {
            this.categoriesByName[cat].children.forEach((child) => {
              subList.push(child);
            });
          });
        }

        return subList;
      },
      //tally methods
      learnMoreTallyClicks(id) {
        let tally = this.tally.find((item) => item.clickData.on == id);
        return tally.count;
      },
      loadTestimonialById() {
        if (this.$route.params.hasOwnProperty("id")) {
          let id = this.$route.params.id;
          let business = this.businesses.find((b) => b.id == id);
          this.activeTab = 4;
          this.open(business, id);
        }
      },
      openTestimonialDialog(item) {
        this.testimonialItem = item;
        this.testimonialDialogBox = true;
      },
      featuredTestimonial(testimonialItem) {
        if (this.testimonialItem.featured === true) {
          this.testimonialItem.visible = true;
        }
      },
      openLearnMoreDialog(item) {
        this.learnMoreItem = item;
        this.learnMoreDialogBox = true;
      },
      fileChange(ev) {
        const file = ev.target.files[0];
        this.fileData.data = file;
        this.fileData.meta = { name: file.name, type: file.type };
        let extension = file.name.split(".");
        if (this.promotionFileChangeChoice == "LearnMore") {
          this.fileData.meta.name = `${Date.now()}_${this.formData.id}_${
            this.promotionFileChangeChoice
          }.${extension[extension.length - 1]}`;
        } else {
          this.fileData.meta.name = `${this.formData.id}_${
            this.promotionFileChangeChoice
          }.${extension[extension.length - 1]}`;
        }
      },
      uploadPromotionFile() {
        this.saving = true;
        this.$store.dispatch("business/uploadFile", this.fileData).then((url) => {
          if (this.promotionFileChangeChoice == "Desktop") {
            this.formData.desktopUrl = url;
          } else if (this.promotionFileChangeChoice == "Mobile") {
            this.formData.mobilUrl = url;
          } else {
            this.formData.destinationUrl = url;
          }
          this.save();
        });
      },
      saveTestimonialItem() {
        this.saving = true;

        this.formData.testimonial[
          this.testimonialItem.idx
        ] = this.testimonialItem;

        this.save();
      },
      saveLearnMoreItem() {
        this.saving = true;
        if (typeof this.fileData.meta != "undefined") {
          this.$store
            .dispatch("business/uploadFile", this.fileData)
            .then((url) => {
              if (this.learnMoreItem.idx == -1) {
                this.learnMoreItem.idx = this.formData.learnMore.length;
              }
              this.learnMoreItem.fileLink = url;
              this.learnMoreItem.business_id = this.formData.id;
              this.formData.learnMore[
                this.learnMoreItem.idx
              ] = this.learnMoreItem;
              this.save();
            });
        } else {
          if (this.learnMoreItem.idx == -1) {
            this.learnMoreItem.idx = this.formData.learnMore.length;
          }
          this.learnMoreItem.fileLink = this.formData.learnMore[
            this.learnMoreItem.idx
          ].fileLink;
          this.learnMoreItem.business_id = this.formData.id;
          this.formData.learnMore[this.learnMoreItem.idx] = this.learnMoreItem;
          this.save();
        }
      },
      updatePaperDirectoryChanged() {
        let d = new Date();
        let month = d.getMonth() + 1;
        if (month < 10) {
          month = "0" + month;
        }
        let day = d.getDate();
        if (day < 10) {
          day = "0" + day;
        }
        this.formData.paperDirectoryLastChanged =
          d.getFullYear() + "-" + month + "-" + day;
      },
      moveDown(idx) {
        let b = this.$clone(this.formData.ourWork[idx + 1]);
        b.idx = this.formData.ourWork[idx + 1].idx = idx;
        this.formData.ourWork[idx + 1] = this.formData.ourWork[idx];
        this.formData.ourWork[idx + 1].idx = idx + 1;
        this.formData.ourWork[idx] = b;
        this.save();
      },
      moveUp(idx) {
        let b = this.$clone(this.formData.ourWork[idx - 1]);
        b.idx = this.formData.ourWork[idx - 1].idx = idx;
        this.formData.ourWork[idx - 1] = this.formData.ourWork[idx];
        this.formData.ourWork[idx - 1].idx = idx - 1;
        this.formData.ourWork[idx] = b;
        this.save();
      },
      toggleForm() {
        if (!this.formOpen) {
          this.formData = {};
        }
        this.formOpen = !this.formOpen;
        this.selectCity = [];
        this.selectRegion = [];
        this.locations = [];
        this.fullLocationData = [];
      },
      open(business, id) {
        this.saving = false;
        this.image = null;
        if (business.category != "" && typeof business.category != "object") {
          business.category = business.category.split(",");
        }
        if (
          business.subCategory != "" &&
          typeof business.subCategory != "object"
        ) {
          business.subCategory = business.subCategory.split(",");
        }
        this.formData = business;
        this.formOpen = true;
        this.$forceUpdate;
        if (business.locations != "") {
          this.locations = business.locations.split(",");
        }
        if (business.serviceDistricts != "") {
          this.selectCity = business.serviceDistricts.split(",");
        }
        if (business.serviceRegions != "") {
          this.selectRegion = business.serviceRegions.split(",");
        }
        let _this = this;
        //disables google location auto completion
        setTimeout(function () {
          _this.$refs.addressInput.$el.setAttribute("autocomplete", "disabled");
          document
            .getElementById("map googleInput")
            .setAttribute("autocomplete", "disabled");
          document
            .getElementById("selectRegionInput")
            .setAttribute("autocomplete", "disabled");
          document
            .getElementById("selectCityInput")
            .setAttribute("autocomplete", "disabled");
        }, 100);
      },
      openWorkDialog(item) {
        this.changeWorkItemImage = false;
        this.workItem = item;
        this.workItemDialog = true;
        this.workItemDialog = true;
      },
      saveWorkItem() {
        this.saving = true;
        this.workItem.business_id = this.formData.id;
        if (this.workItemImage && this.workItemImage.imageSet) {
          this.workItemImage.generateBlob(
            (blob) => {
              this.workItem.image = { file: blob };
              if (!this.formData.ourWork) {
                this.formData.ourWork = [];
              }
              if (this.workItem.idx === -1) {
                this.workItem.idx = this.formData.ourWork.length;
              }
              this.$store
                .dispatch("business/saveWorkItemImage", this.workItem)
                .then((workItemUrl) => {
                  this.workItem.imageUrl = workItemUrl;
                  delete this.workItem.image;
                  this.formData.ourWork[this.workItem.idx] = this.workItem;

                  this.save();
                });
            },
            "image/jpeg",
            1
          );
        } else {
          this.formData.ourWork[this.workItem.idx] = this.workItem;
          this.save();
        }
      },
      saveWorkItemVideo() {
        this.saving = true;
        if (!this.formData.ourWork) {
          this.formData.ourWork = [];
        }
        if (this.workItem.idx === -1) {
          this.workItem.idx = this.formData.ourWork.length;
        }
        let VID_REGEX = /(?:youtube(?:-nocookie)?\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
        let videoID = this.workItem.videoUrl.match(VID_REGEX)[1];
        this.workItem.videoID = videoID;
        this.workItem.business_id = this.formData.id;
        this.formData.ourWork[this.workItem.idx] = this.workItem;

        this.save();
      },
      save() {
        if (this.$refs.profileForm.validate()) {
          this.saving = true;
          this.formData.serviceRegions = this.selectRegion.toString();
          this.formData.serviceDistricts = this.selectCity.toString();
          this.formData.locations = this.locations.toString();
          if (this.formData.category) {
            this.formData.category = this.formData.category.toString();
          }
          if (this.formData.subCategory) {
            this.formData.subCategory = this.formData.subCategory.toString();
          }
          this.formData.locationsJSON = JSON.stringify(this.fullLocationData);
          if (this.image && this.image.imageSet) {
            this.image.generateBlob(
              (blob) => {
                this.formData.image = { file: blob };

                this.$store
                  .dispatch("business/save", this.formData)
                  .then((business) => {
                    if (
                      business.category != "" &&
                      typeof business.category != "object"
                    ) {
                      business.category = business.category.split(",");
                    }
                    if (
                      business.subCategory != "" &&
                      typeof business.subCategory != "object"
                    ) {
                      business.subCategory = business.subCategory.split(",");
                    }
                    this.formData = business;
                    this.changeImage = false;
                    this.saving = false;
                    this.workItemDialog = false;
                    this.learnMoreDialogBox = false;
                    this.fileData = {};
                    this.changePromotionFileDialog = false;
                    this.testimonialDialogBox = false;

                    this.fileData = {};
                  });
              },
              "image/jpeg",
              0.9
            );
          } else {
            this.$store
              .dispatch("business/save", this.formData)
              .then((business) => {
                if (
                  business.category != "" &&
                  typeof business.category != "object"
                ) {
                  business.category = business.category.split(",");
                }
                if (
                  business.subCategory != "" &&
                  typeof business.subCategory != "object"
                ) {
                  business.subCategory = business.subCategory.split(",");
                }
                this.formData = business;
                this.saving = false;
                this.workItemDialog = false;
                this.learnMoreDialogBox = false;
                this.fileData = {};
                this.changePromotionFileDialog = false;
                this.testimonialDialogBox = false;
                this.fileData = {};
              });
          }
        }
      },
      deleteBusiness() {
        this.$confirm("Are you sure you want to delete this business?").then(
          (res) => {
            if (res) {
              this.deleting = true;
              this.$store
                .dispatch("business/delete", this.formData.id)
                .then((res) => {
                  this.formOpen = false;
                  this.deleting = false;
                });
            }
          }
        );
      },
      deleteWorkItem(workItem) {
        this.$confirm("Are you sure you want to delete this work example?").then(
          (res) => {
            if (res) {
              this.deleting = true;
              // this.formData.ourWork.splice(
              //   this.formData.ourWork[workItem.idx],
              //   1
              // );
              this.$store
                .dispatch("business/deleteOurWork", workItem.id)
                .then((res) => {
                  this.deleting = false;
                  let ourWork = this.formData.ourWork.filter(
                    (OW) => OW != workItem
                  );
                  this.formData.ourWork = ourWork;
                });
            }
          }
        );
      },
      deleteLearnMore(learnMore) {
        this.$confirm("Are you sure you want to delete this work example?").then(
          (res) => {
            if (res) {
              this.deleting = true;
              // this.formData.ourWork.splice(
              //   this.formData.ourWork[workItem.idx],
              //   1
              // );
              this.$store
                .dispatch("business/deleteLearnMore", learnMore.id)
                .then((res) => {
                  this.deleting = false;
                  let learnMoreList = this.formData.learnMore.filter(
                    (LM) => LM != learnMore
                  );
                  this.formData.learnMore = learnMoreList;
                });
            }
          }
        );
      },
      deleteTestimonial(data) {
        this.$confirm("Are you sure you want to delete this testimonial?").then(
          (res) => {
            if (res) {
              this.deleting = true;

              this.$store
                .dispatch("business/deleteTestimonial", data.id)
                .then((res) => {
                  this.deleting = false;
                  let testimonial = this.formData.testimonial.filter(
                    (OW) => OW != data
                  );
                  this.formData.testimonial = testimonial;
                });
            }
          }
        );
      },
    },
  };
</script>

<style>
  .croppa-container {
    margin-left: auto;
    margin-right: auto;
    position: relative;
  }

  .croppa-container canvas {
    border: 1px solid;
  }

  .icon-remove {
    position: absolute;
    top: 5px !important;
    right: -35px !important;
  }
</style>
